<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
            {{ userStore.user.address }}<br/>
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }} <br>
            {{ userStore.user.ssn }} <br>
            <br>
            {{ creditBureau.address_name }} <br>
            {{ creditBureau.street_address }} <br>
            {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }}
            <br>
            <br>
            Date: {{ date }}
        </p>
        <p><strong>RE: Second request for removal of inaccurate information </strong></p>
        <p>
            <strong>ATTN:</strong> {{ creditBureau.name }} Legal Department,
        </p>
        <p class="letter-content">
            I am deeply concerned and disappointed in your silence. Please note that this is the second time I’m writing to request that you validate the inaccurate information on my credit report. My first letter to you explained everything that I found to be inaccurate on my credit report. I do understand my rights as a consumer and so I’m well aware of the fact that as a credit reporting agency, you are mandated by law to respond to my disputes within a maximum of 30 calendar days of receiving my dispute. Beyond that point, if you fail or refuse to respond, then the information disputed must automatically be deleted. With that being said, I’m writing to inform you that it has now been more than a month. I have not received a single response from you!
        </p>
        <p class="letter-content">
            This letter is due to a lack of response from your company to my initial re-investigation request within the 30-day time frame allowed by law. I restate, the following information needs to be removed immediately:
        </p>
        <p>
            <template v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
                <strong>NAME OF ACCOUNT: </strong>
                <span style="color: #ea5455;" class="text-danger">{{ creditor.furnisher_name }}</span>
                <br />
                <template v-if="creditor.reference_number">
                    <strong>REFERENCE NUMBER: </strong>{{ creditor.reference_number }}
                    <br />
                </template>
                <template v-else>
                    <strong>ACCOUNT NUMBER: </strong>{{ creditor.account_number }}
                    <br />
                </template>
                I demand that you delete this <strong>UNVERIFIED ACCOUNT immediately.</strong>
                <br />
                <br />
            </template>
        </p>
        <p>
            Thank you for your time, <br> <br>
            <span style="color: #ea5455;" class="text-danger">
                {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            </span>
            <br />
        </p>
    </div>
    <h1 style="margin: 5rem 5rem;">Personal Information</h1>
    <div class="row">
        <p>
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>